import { render, staticRenderFns } from "./nova_loja.vue?vue&type=template&id=2296d9ae&scoped=true&"
import script from "./nova_loja.vue?vue&type=script&lang=js&"
export * from "./nova_loja.vue?vue&type=script&lang=js&"
import style0 from "./nova_loja.vue?vue&type=style&index=0&id=2296d9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296d9ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VForm,VProgressCircular,VSwitch})
